export const achievementData = {
    bio : "Putting quantified achievements on a resume is great, but I just don’t work with hard numbers. I have no data to support the quality of my work. If you have lots of relevant experience, the heading statement of your resume will be a summary.",
    achievements : [
        {
            id : 1,
            title : 'Data Analysis with R Programming',
            details : 'Explain the fundamental concepts associated with programming in R including functions, variables, data types, pipes, and vectors',
            date : 'Aug 06, 2021',
            field : 'By Google',
            image : 'https://s3.amazonaws.com/coursera_assets/meta_images/generated/CERTIFICATE_LANDING_PAGE/CERTIFICATE_LANDING_PAGE~EF7E23J4B3QF/CERTIFICATE_LANDING_PAGE~EF7E23J4B3QF.jpeg'
        },
        {
            id : 2,
            title : 'Coursera Certification',
            details : 'Demonstrate the skills required for an entry-level data engineering role.',
            date : 'Aug 03, 2021',
        
            field : 'Introduction to Data Engineering',
            image : 'https://s3.amazonaws.com/coursera_assets/meta_images/generated/CERTIFICATE_LANDING_PAGE/CERTIFICATE_LANDING_PAGE~ASWQ7WX3DZQB/CERTIFICATE_LANDING_PAGE~ASWQ7WX3DZQB.jpeg'
        },
        {
            id : 3,
            title : 'Machine Learning, and Deep Learning',
            details : 'Introduction to TensorFlow for Artificial Intelligence, Machine Learning, and Deep Learning',
            date : 'Aug 03, 2021',
            field : 'DeepLearning.AI',
            image : 'https://s3.amazonaws.com/coursera_assets/meta_images/generated/CERTIFICATE_LANDING_PAGE/CERTIFICATE_LANDING_PAGE~X7B3KL6CN45S/CERTIFICATE_LANDING_PAGE~X7B3KL6CN45S.jpeg'
        },
        

    ]
}


// Do not remove any fields.
// Leave it blank instead as shown below.

/*

export const achievementData = {
    bio : "",
    achievements : []
}

*/